import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const BeneficiaryRelationConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/beneficiary-relation",
    component: React.lazy(() => import("./beneficiary-relation")),
  },
];
